import * as React from 'react'
import { lightTheme } from '@/customTheme'

/** Position "Centered" mode icon (Figma 12082:22392): frame with a centered inner square. */
function PositionCenteredIcon({ size = 24, color = lightTheme.colors.blackGray }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="20" height="20" rx="2" stroke={color} strokeWidth="2" />
      <rect x="7" y="7" width="10" height="10" rx="1" stroke={color} strokeWidth="2" />
    </svg>
  )
}

export default PositionCenteredIcon
